import {
  STANDS_PENDING,
  STANDS_FAILED,
  STANDS_DOWNLOADED,
  STANDS_RESET,
  STAND_SENDING,
  STAND_DOWNLOADED,
} from './types';

export const INITIAL_STATE = {
  error: null,
  content: null,
  pending: false,
  sending: false,
};

export default function (state = INITIAL_STATE, action) {
  let stands = [];
  let standIndex = -1;
  switch (action.type) {
    case STANDS_RESET:
      return INITIAL_STATE;
    case STANDS_PENDING:
      return {
        ...state,
        error: null,
        pending: true,
      };
    case STANDS_DOWNLOADED:
      return {
        error: null,
        pending: false,
        sending: false,
        content: action.payload,
      };
    case STAND_SENDING:
      return {
        ...state,
        sending: true,
      };
    case STAND_DOWNLOADED:
      if (state.content) {
        stands = state.content.slice();
        standIndex = stands.findIndex((stand) => stand.id === action.payload.id);
      }
      if (standIndex === -1) {
        stands.push(action.payload);
      } else {
        stands[standIndex] = action.payload;
      }
      return {
        error: null,
        pending: false,
        sending: false,
        content: stands,
      };
    case STANDS_FAILED:
      return {
        ...state,
        error: action.payload,
        pending: false,
        sending: false,
      };
    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/store/stands/reducers.js